import initialState from '~scenes/madeforyou/app/store/initialState';
import {
    MADE_FOR_YOU_SET_ACTIVE_TAB,
    MADE_FOR_YOU_PUSH_ACTIVE_TAB,
    MADE_FOR_YOU_SET_TAB_LIST,
} from './../actions/mfyActionTypes';

/**
 * Main tabs reducer
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
export default function tabsReducer(state = initialState, action) {
    switch (action.type) {
        case MADE_FOR_YOU_SET_ACTIVE_TAB: {
            return {
                ...state,
                activeTab: action.tab,
            };
        }
        case MADE_FOR_YOU_SET_TAB_LIST: {
            return {
                ...state,
                tabList: action.tabList,
            };
        }
        case MADE_FOR_YOU_PUSH_ACTIVE_TAB: {
            return {
                ...state,
                activeTab: action.tab,
            };
        }
        default:
            return state;
    }
}
